import { Form, Input, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import rpmService from "../../../../Services/rpmService";
import { useDispatch } from "react-redux";
import { convertUTCDate } from "../../../../utils/convertionFunc";
import { fetchRpmVitalsRangeList } from "../../../../Redux/actions/rpmActions";

function UpdateVital({ selectedVital, handleEditModal }) {
  const [loader, setLoader] = useState(false);
  const formRef = useRef();
  const dispatch = useDispatch();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    formRef.current.setFieldsValue({
      minimumNormalRange: selectedVital?.minimumNormalRange,
      maximumNormalRange: selectedVital?.maximumNormalRange,
      minimumAbnormalRange: selectedVital?.minimumAbnormalRange,
      minimumNormalRangeMinusOne: selectedVital?.minimumNormalRange - 1,
      maximumNormalRangePlusOne: selectedVital?.maximumNormalRange + 1,
      maximumAbnormalRange: selectedVital?.maximumAbnormalRange,
    });
  }, [selectedVital]);

  const handleUpdateVital = async () => {
    const {
      minimumNormalRange,
      maximumNormalRange,
      minimumAbnormalRange,
      maximumAbnormalRange,
    } = formRef.current.getFieldValue();

    setLoader(true);
    const payload = {
      createdBy: loggedUser?.user?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      id: selectedVital.id,
      maximumAbnormalRange:
        selectedVital?.maximumAbnormalRange !== maximumAbnormalRange
          ? maximumAbnormalRange
          : selectedVital?.maximumAbnormalRange,
      maximumNormalRange:
        selectedVital?.maximumNormalRange !== maximumNormalRange
          ? parseInt(maximumNormalRange)
          : selectedVital?.maximumNormalRange,
      minimumAbnormalRange:
        selectedVital?.minimumAbnormalRange !== minimumAbnormalRange
          ? minimumAbnormalRange
          : selectedVital?.minimumAbnormalRange,
      minimumNormalRange:
        selectedVital?.minimumNormalRange !== minimumNormalRange
          ? parseInt(minimumNormalRange)
          : selectedVital?.minimumNormalRange,
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      name: selectedVital.name,
      status: 1,
      vitalCode: selectedVital.vitalCode,
      vitalsRangeCreatedBy: loggedUser?.user?.userId,
    };

    try {
      await rpmService.updateRpmVital(payload);
      setLoader(false);
      const vitalRangePayload = {
        status: 1,
      };
      dispatch(fetchRpmVitalsRangeList(vitalRangePayload));
      handleEditModal(null, "close");
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
  };

  const handleCloseModal = () => {
    handleEditModal(null, "close");
  };

  return (
    <div>
      <Form layout="vertical" ref={formRef}>
        <div className="grid grid-cols-2 items-center gap-1">
          <div className="flex items-center gap-2 mb-2">
            <label className="text-sm font-medium text-[#333333] whitespace-nowrap">
              Vital <span className="mx-1">:</span>
            </label>
            <Input
              disabled
              value={selectedVital.name}
              className="max-w-[200px] bg-gray-100 text-gray-500"
            />
          </div>
          <br />
          <div>
            <Form.Item
              label={
                <span>
                  Normal Range <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="minimumNormalRange"
            >
              <Input placeholder="" />
            </Form.Item>
          </div>
          <div>
            <Form.Item label="Range" name="maximumNormalRange">
              <Input placeholder="" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Min Abnormal Range <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="minimumAbnormalRange"
            >
              <Input placeholder="" />
            </Form.Item>
          </div>
          <div>
            <Form.Item label="Range" name="minimumNormalRangeMinusOne">
              <Input placeholder="" disabled />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Max Abnormal Range <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="maximumNormalRangePlusOne"
            >
              <Input placeholder="" disabled />
            </Form.Item>
          </div>
          <div>
            <Form.Item label="Range" name="maximumAbnormalRange">
              <Input />
            </Form.Item>
          </div>
        </div>
      </Form>
      <div className="flex items-center w-full justify-end my-5">
        <button
          onClick={handleCloseModal}
          className="border-brand-primaryColor  bg-white border rounded text-sm px-6 py-1.5"
        >
          Cancel
        </button>
        <button
          onClick={handleUpdateVital}
          disabled={loader}
          className="bg-brand-primaryColor text-white border-brand-primaryColor border rounded px-5 py-1.5 text-brand-textWhite text-sm ml-3 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default UpdateVital;
